import { useState, useEffect } from 'react';

export function usePlatform() {
  const [platform, setPlatform] = useState('unknown');

  useEffect(() => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      setPlatform('desktop');
      return;
    }

    const ua = navigator.userAgent || '';
    const isAndroid = /Android/i.test(ua);
    const isIOS =
      /iPhone|iPad|iPod/i.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const isStandalone =
      window.matchMedia?.('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;

    if (isAndroid) {
      setPlatform('android');
      return;
    }

    if (isIOS || isStandalone) {
      setPlatform('ios-pwa');
      return;
    }

    setPlatform('desktop');
  }, []);

  return platform;
}
